import * as React from 'react'
import * as Router from 'react-router-dom'

export function Header() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 shadow-md bg-milky">
      <div className="flex justify-between items-center h-14 max-w-6xl mx-auto lg:px-14 md:px-10 sm:px-8 px-6" >
        <Router.Link to="/" className="text-2xl font-semibold">TeaCon 茶后谈</Router.Link>
      </div>
    </header>
  )
}
